module.exports = {
    DAYS_OF_THE_WEEK: Object.freeze([
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота',
        'Воскресенье',
    ]),
}